module.exports = __webpack_public_path__ + "media/lucky.84444287.mp3";